<template>
  <div class="joinUs">
    <div class="head">
<!--      -->
<!--      <p class="title">加入我们</p>-->
<!--      <p class="sub-title">JOIN US</p>-->

<!--      <a-->
<!--          class="join-link"-->
<!--          href="http://zp.cdjc.com.cn:9100"-->
<!--          target="_blank"-->
<!--          rel="noopener noreferrer"-->
<!--      >-->
<!--        <p class="title">【点击】加入我们</p>-->
<!--        <p class="sub-title">JOIN US</p>-->
      <a href="http://zp.cdjc.com.cn:9100" class="join-us-bar">
        <div class="join-text">
          <span class="title">加入我们</span>
          <span class="sub-title">JOIN US</span>
        </div>
        <span class="arrow">→</span>
      </a>







<!--      </a>-->

      <div class="children">
<!--        <a class="one" href="#idea" :class="{ active: opt == 0 }">人才理念</a>-->
<!--        <a class="two" href="#msg" :class="{ active: opt == 1 }">招贤纳士</a>-->
      </div>
    </div>
    <div id="idea">
      <div>
        <p class="title">人才理念</p>
        <p class="sub-title">Talent conce</p>
        <div>
          <div v-for="(item, index) in rc" :key="index">
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="desc">{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div id="msg">-->
<!--      <p class="title">招贤纳士</p>-->
<!--      <p class="sub-title">Recruitment</p>-->
<!--      <div v-for="(item, index) in zp.data" :key="index">-->
<!--        <div class="li" @click="changeZP(index)">-->
<!--          <span class="title">{{ item.name }}</span>-->
<!--          <span class="desc"-->
<!--            >{{ item.city }} 丨 {{ item.xl }} 丨 招{{ item.num }}人</span-->
<!--          >-->
<!--          <i :class="show !== index ? 'el-icon-plus' : 'el-icon-minus'"></i>-->
<!--        </div>-->
<!--        <transition name="fade">-->
<!--          <div class="content" v-show="show == index">-->
<!--            <div class="rich" v-html="item.content"></div>-->
<!--            <p class="type">联系我们</p>-->
<!--            <p class="options">-->
<!--              <i class="el-icon-phone"></i>-->
<!--              <span>电话：{{ item.tel }}</span>-->
<!--              <i class="el-icon-message"></i>-->
<!--              <span>邮箱：{{ item.yx }}</span>-->
<!--            </p>-->
<!--            <p class="type">我要应聘</p>-->
<!--            <p class="inps">-->
<!--              <span>姓名：</span>-->
<!--              <input type="text" name id v-model="form.name" />-->
<!--              <span>电话：</span>-->
<!--              <input type="number" name id v-model="form.tel" />-->
<!--              <span>应聘职位：</span>-->
<!--              <input type="text" name id v-model="form.zw" />-->
<!--              <button class="submit" @click="submit">提交</button>-->
<!--            </p>-->
<!--          </div>-->
<!--        </transition>-->
<!--      </div>-->
<!--    </div>-->
<!--    <el-pagination-->
<!--      :page-size="6"-->
<!--      background-->
<!--      layout="prev, pager, next"-->
<!--      :total="zp.total"-->
<!--      @current-change="change"-->
<!--    ></el-pagination>-->
  </div>
</template>

<script>
import { rc, zp, bm } from '../assets/js/api'
export default {
  data() {
    return {
      opt: 0,
      show: -1,
      rc: {},
      zp: {},
      page: 1,
      form: {},
    }
  },
  created() {
    rc().then((r) => {
      this.rc = r.data.data
    })
    this.getData()
  },
  mounted() {
    let idea = document.getElementById('idea').offsetTop
    let msg = document.getElementById('msg').offsetTop
    window.addEventListener('scroll', (e) => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop <= idea) {
        this.opt = 0
      } else {
        this.opt = 1
      }
    })
  },
  methods: {
    submit() {
      if (!this.form.name) {
        this.$message.error('请输入姓名')
        return false
      }
      if (!this.form.tel) {
        this.$message.error('请输入电话')
        return false
      }
      if (!this.form.zw) {
        this.$message.error('请输入职位')
        return false
      }
      bm(this.form).then((r) => {
        this.$message.success('成功')
        setTimeout(() => {
          location.reload()
        }, 1500)
      })
    },
    changeZP(e) {
      this.show = this.show == e ? -1 : e
      this.form.zp_id = this.zp.data[this.show].id
    },
    change(e) {
      this.page = e
      this.show = -1
      this.getData()
    },
    getData() {
      zp({
        limit: 6,
        page: this.page,
      }).then((r) => {
        this.zp = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.joinUs {
  padding-bottom: 90px;
}

.head {
  width: 100%;
  height: 580px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('../assets/img/join_banner.png');
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    font-size: 42px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .sub-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }

  .children {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    left: 0;

    & > a {
      width: 200px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.78);
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      margin-right: 10px;
      cursor: pointer;
      text-decoration: none;
    }

    & > a.active {
      background: #126fcc;
      border: none;
    }
  }
}

.title {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(255, 253, 253, 1);
  text-align: center;
}

.sub-title {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  margin-bottom: 90px;
}

#idea {
  width: 100%;
  height: 530px;
  background-size: cover;
  background-image: url('../assets/img/join-us.png');
  background-repeat: no-repeat;
  padding: 90px 0;
  box-sizing: border-box;
  .title{
    font-weight: 500;
  }
  & > div {
    width: 1200px;
    margin: 0 auto;
    font-size: 0;

    & > div {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 1200px;

      & > div {
        width: 45%;
      }

      .name {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 19px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .desc {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 50px;
      }
    }

    & > div:last-child {
      // margin-left: 187px;
    }
  }
}

#msg {
  margin-top: 90px;

  .title {
    color: #000000;
  }

  .sub-title {
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 60px;
  }

  & > div:active {
    opacity: 0.78;
  }

  & > div {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 20px;

    .content {
      padding: 30px;
      box-sizing: border-box;
      width: 100%;
      border: 1px solid rgba(242, 242, 242, 1);
      border-top: 0;

      .type {
        padding-left: 10px;
        border-left: 4px solid #1270cc;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 19px;
      }

      .rich {
        margin-bottom: 40px;
      }

      .options {
        padding-left: 11px;
        margin-bottom: 50px;

        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: rgba(0, 0, 0, 1);
          margin-right: 60px;
        }

        i {
          color: #1270cc;
          margin-right: 10px;
        }
      }

      .inps {
        padding-left: 35px;
        display: flex;
        align-items: center;

        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: rgba(0, 0, 0, 1);
        }

        input {
          width: 170px;
          height: 30px;
          margin-right: 66px;
        }

        button {
          cursor: pointer;
          width: 80px;
          height: 30px;
          background: rgba(18, 112, 204, 1);
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 30px;
          text-align: center;
          outline: none;
          border: none;
        }
      }
    }
  }

  .li {
    height: 80px;
    display: flex;
    align-items: center;

    position: relative;
    border: 1px solid rgba(242, 242, 242, 1);

    padding-left: 29px;
    padding-right: 20px;
    box-sizing: border-box;
    cursor: pointer;

    & > span {
      display: inline-block;

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .title {
      width: 349px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(62, 62, 62, 1);
      margin-right: 50px;
      text-align: left;
    }

    .desc {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(120, 120, 120, 1);
      width: 40%;
    }

    i {
      font-weight: bolder;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.el-pagination {
  margin-top: 50px;
}

//增加招聘官网加入我们 样式

.join-us-bar {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 260px;               /* 固定宽度，显得端庄 */
  padding: 16px 28px;
  background: rgba(15, 23, 42, 0.4); /* 半透明深色背景，阻隔复杂背景，保证文字清晰度 */
  border: 1px solid rgba(255, 255, 255, 0.3); /* 极细的精致边框 */
  backdrop-filter: blur(5px); /* 微弱毛玻璃，让背景双手隐约透出，很有层次 */
  text-decoration: none;
  color: #ffffff;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.join-us-bar .join-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.join-us-bar .title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 1.2;
}

.join-us-bar .sub-title {
  font-size: 10px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

.join-us-bar .arrow {
  font-size: 20px;
  font-family: Arial, sans-serif;
  transition: transform 0.3s ease;
}

/* ================= 悬停动态效果 ================= */
.join-us-bar:hover {
  background: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px); /* 微微上浮 */
}

.join-us-bar:hover .title {
  color: #0f172a; /* 文字变深色 */
}

.join-us-bar:hover .sub-title {
  color: #64748b;
}

.join-us-bar:hover .arrow {
  color: #0f172a;
  transform: translateX(6px); /* 箭头向右滑 */
}





</style>
